module.exports = __webpack_public_path__ + "img/bussiness_mobile_htwl1.f4bd3598.png";